// global
import { combineReducers } from 'redux';

// cruds
import crudPatient from 'app/redux/reducers/crud-patient.reducer';

// PAD LIST
import padListClient from 'app/redux/reducers/pad-list/pad-list-client.reducer';
// patient
import patients from 'app/redux/reducers/patient/patients.reducer';
import patientDetail from 'app/redux/reducers/patient/patient-detail.reducer';
import patientFiles from 'app/redux/reducers/patient/patient-files.reducer';
import patientLastVisits from 'app/redux/reducers/patient/patient-last-visits.reducer';

// permission
// import permissions from 'app/redux/reducers/permission/permission-groups.reducer';
import permissions from 'app/redux/reducers/permissions.reducer';
import groupPermissions from 'app/redux/reducers/permission/group-permissions.reducer';

// notification
import notification from 'app/redux/reducers/notification/notification.reducer';
import notifiables from 'app/redux/reducers/notification/notifiable.reducer';

// overlay
import errorOverlay from 'app/redux/reducers/error-overlay.reducer';

// visit
import visitList from 'app/redux/reducers/visit/visit-list.reducer';
// import visitDetail from 'app/redux/reducers/visit/visit-detail.reducer';
import visitDetail from 'app/redux/reducers/visit-detail/visit-detail.reducer';
import reportPDFVisitDetail from 'app/redux/reducers/visit/report-pdf.reducer';
import visitDetailFull from 'app/redux/reducers/visit-detail/visit-detail-full.reducer';
import visitReportPDF from 'app/redux/reducers/visit/visit-report-pdf.reducer';
import visitFullReportPDF from 'app/redux/reducers/visit/visit-full-report-pdf.reducer';
import extensionReportPDF from 'app/redux/reducers/visit/extension-report-pdf.reducer';
import plannedVisitsProfessional from 'app/redux/reducers/visit/planned-visits-professional.reducer';
import completedVisitsProfessional from 'app/redux/reducers/visit/completed-visits-professional.reducer';
import visitPages from 'app/redux/reducers/visit/visit-pages.reducer';
import professionalsVisits from 'app/redux/reducers/visit/professionals-visits.reducer';
import monthVisits from 'app/redux/reducers/visit/month-visits.reducer';
import weekVisits from 'app/redux/reducers/visit/week-visits.reducer';
import visitsInitialAssessment from 'app/redux/reducers/visit/visits-initial-assessment.reducer.js';
import customHealthScale from 'app/redux/reducers/customHealthScale.reducer.js';
import deleteVisitModal from 'app/redux/reducers/visit/delete-visit-modal.reducer';
import checkingCheckoutModal from 'app/redux/reducers/visit-detail/checking-checkout/checking-checkout-modal.reducer.js';

// VisitDashboard
// import visitDashboard from 'app/redux/reducers/visit/visit-dashboard.reducer';
import visitDashboardList from 'app/redux/reducers/visit-dashboard/visit-dashboard-list.reducer';
import visitDashboardCounter from 'app/redux/reducers/visit-dashboard/visit-dashboard-counter.reducer';

// link professional
import linkProfessionalVisitDetail from 'app/redux/reducers/visit/link-professional/link-professional-visit-detail.reducer';
import linkProfessionalVisitCalendar from 'app/redux/reducers/visit/link-professional/link-professional-visit-calendar.reducer';
import linkProfessionalVisit from 'app/redux/reducers/visit/link-professional/link-professional-visit.reducer';

// professionals
import professionalAvailability from 'app/redux/reducers/professional-availability/professional-availability.reducer.js';

// health professionals
import nursingTechnician from 'app/redux/reducers/nursing-technician.reducer';
import speechTherapists from 'app/redux/reducers/speech-therapists.reducer';
import nursingAssistant from 'app/redux/reducers/nursing-assistant.reducer';
import doctors from 'app/redux/reducers/doctors.reducer';
import professionals from 'app/redux/reducers/professionals.reducer';

// others
import auth from 'app/redux/reducers/auth.reducer';
import users from 'app/redux/reducers/users.reducer';
import clients from 'app/redux/reducers/clients.reducer';
import snackbar from 'app/redux/reducers/snackbar.reducer';
import healthInsurance from 'app/redux/reducers/health-insurance.reducer';
import notificationMessages from 'app/redux/reducers/notification-message.reducer';
import responsibles from 'app/redux/reducers/responsibles.reducer';
import download from 'app/redux/reducers/download.reducer';
import attendances from 'app/redux/reducers/attendances.reducer';
import searchAddress from 'app/redux/reducers/search-address.reducer';
import dashboard from 'app/redux/reducers/dashboard.reducer';
import dashboardSearch from 'app/redux/reducers/dashboardSearch.reducer';
import measurementUnity from 'app/redux/reducers/measurement-unity.reducer';
import cid from 'app/redux/reducers/cid.reducer';
import nandaDomain from 'app/redux/reducers/nanda-domain.reducer';
import nandaDiagnostic from 'app/redux/reducers/nanda-diagnostic.reducer';
import nandaClass from 'app/redux/reducers/nanda-class.reducer';
import kit from 'app/redux/reducers/kit.reducer';
import kitModal from 'app/redux/reducers/kit-modal.reducer';
import equipment from 'app/redux/reducers/equipment.reducer';
import matMed from 'app/redux/reducers/matMed.reducer';
import evaluationAnswer from 'app/redux/reducers/evaluationAnswer.reducer';
import evaluationQuestion from 'app/redux/reducers/evaluationQuestion.reducer';
import evaluations from 'app/redux/reducers/evaluations.reducer';
import kitMatMed from 'app/redux/reducers/kit-mat-med.reducer';
import evaluationQuestionOption from 'app/redux/reducers/evaluationQuestionOption.reducer';
import clinicalEvolution from 'app/redux/reducers/clinicalEvolution.reducer';
import clinicalEvolutionSignSymptom from 'app/redux/reducers/clinical-evolution-sign-symtpom.reducer';
import prescriptionTranscription from 'app/redux/reducers/prescriptionTranscription.reducer';
import diagnostics from 'app/redux/reducers/diagnostic.reducer';
import diagnosticNANDA from 'app/redux/reducers/diagnosticNANDA.reducer';
import diagnosticCID from 'app/redux/reducers/diagnosticCID.reducer';
import equipmentIndication from 'app/redux/reducers/equipment-indication.reducer';
import furnitureIndication from 'app/redux/reducers/furniture-indication.reducer';
import professionIndication from 'app/redux/reducers/profession-indication.reducer';
import branch from 'app/redux/reducers/branch.reducer';
import visitationType from 'app/redux/reducers/visitation-type.reducer';
import evaluationType from 'app/redux/reducers/evaluationType.reducer';
import inventary from 'app/redux/reducers/inventary.reducer';
import equipmentInventary from 'app/redux/reducers/equipment-inventary.reducer';
import furnitureInventary from 'app/redux/reducers/furniture-inventary.reducer';
import prescription from 'app/redux/reducers/prescription.reducer';
import prescriptionContent from 'app/redux/reducers/prescription-content.reducer';
import signSymptom from 'app/redux/reducers/sign-symptom.reducer';
import previewEvaluation from 'app/redux/reducers/preview-evaluation.reducer';
import administrationRoute from 'app/redux/reducers/administration-route.reducer';
import alertBand from 'app/redux/reducers/alertBand.reduce.js';
import professionalPrescriberModal from 'app/redux/reducers/professional-prescriber/professional-prescriber.reducer';
// prescription menu
import prescriptionMenu from 'app/redux/reducers/prescription-menu/prescription-menu.reducer';
import prescriptionMenuCards from 'app/redux/reducers/prescription-menu/prescription-menu-cards.reducer';

// routing
import routing from 'app/redux/reducers/routing/routing.reducer';
import routingMap from 'app/redux/reducers/routing/routing-map.reducer';

// procedure
import procedure from 'app/redux/reducers/procedure.reducer';
import kitProcedure from 'app/redux/reducers/kit-procedure.reducer';

// pad - monitoring
import printPrescriptionScheduleSheetModal from 'app/redux/reducers/pad-menu/print-prescription-schedule-sheet-modal.reducer';
import prescriptionScheduleSheet from 'app/redux/reducers/prescription-schedule-sheet.reducer';
import monitoring from 'app/redux/reducers/monitoring/monitoring.reducer';
import padMonitoringTabs from 'app/redux/reducers/monitoring/pad-monitoring-tabs.reducer';
import patientList from 'app/redux/reducers/patient-list/patient-list.reducer';
import patientMonthVisits from 'app/redux/reducers/monitoring/patient-visits/patient-month-visits.reducer';
import patientWeekVisits from 'app/redux/reducers/monitoring/patient-visits/patient-week-visits.reducer';
import patientVisits from 'app/redux/reducers/monitoring/patient-visits/patient-visits.reducer';
import monthlySchedule from 'app/redux/reducers/pad-monitoring/visits/monthly-schedule.reducer';
import padMonitoringVisits from 'app/redux/reducers/pad-monitoring/visits/pad-monitoring-visits.reducer';
// import monthDoctorPrescription from 'app/redux/reducers/monitoring/doctor-prescription/month-doctor-prescription.reducer';
// import weekDoctorPrescription from 'app/redux/reducers/monitoring/doctor-prescription/week-doctor-prescription.reducer';
// import monthNursingPrescription from 'app/redux/reducers/monitoring/nursing-prescription/month-nursing-prescription.reducer';
// import weekNursingPrescription from 'app/redux/reducers/monitoring/nursing-prescription/week-nursing-prescription.reducer';
import prescriptionMatMed from 'app/redux/reducers/monitoring/prescription/prescription-mat-med.reducer';
import businessPartner from 'app/redux/reducers/business-partner.reducer';
import padDetail from 'app/redux/reducers/pad-detail.reducer';
import weekPrescription from 'app/redux/reducers/monitoring/prescription/week-prescription.reducer';
import padItem from 'app/redux/reducers/pad-item.reducer';
import padPrescription from 'app/redux/reducers/pad-prescription.reducer';
import padVisits from 'app/redux/reducers/pad-visits.reducer';
import padDashboard from 'app/redux/reducers/padDashboard.reducer';
// import initializePad from 'app/redux/reducers/pad-menu/initialize-pad.reducer';
import initializePad from 'app/redux/reducers/initialize-pad/initialize-pad.reducer';
import padInitialization from 'app/redux/features/pad-initialization/reducer/rootReducer';
import feedback from 'app/redux/reducers/initialize-pad/feedback.reducer';
import profession from 'app/redux/reducers/profession.reducer';
import healthProfessional from 'app/redux/reducers/health-professional.reducer';
import padMenuClient from 'app/redux/reducers/pad-menu/pad-menu-client.reducer';
import padMenuCooperative from 'app/redux/reducers/pad-menu/pad-menu-cooperative.reducer';
import calendar from 'app/redux/reducers/initialize-pad/calendar.reducer.js';
import attendanceReleaseModal from 'app/redux/reducers/attendances-release-modal.reducer';
import confirmationPadModal from 'app/redux/reducers/pad-menu/confirmation-pad-modal.reducer';
import professionalPrescriptorModal from 'app/redux/reducers/professional-prescriptor/professional-prescriptor-modal.reducer';
import professionalPrescriptor from 'app/redux/reducers/professional-prescriptor/professional-prescriptor.reducer';
import healthProfessionalList from 'app/redux/reducers/health-professional-list/health-professional-list.reducer';
// PEP
import PEPList from 'app/redux/reducers/pep/pep-list.reducer';
import patientsPEP from 'app/redux/reducers/pep/patients-pep.reducer';
import patientDetailPEP from 'app/redux/reducers/pep/patient-detail-pep.reducer';
import furniturePep from 'app/redux/reducers/pep/panes/furniture/furniture-pep.reducer';
import matMedPEP from 'app/redux/reducers/pep/panes/mat-med/mat-med-pep.reducer';
import prescriptionPEP from 'app/redux/reducers/pep/panes/prescription/prescription-pep.reducer';
import prescriptionConsolidatePEP from 'app/redux/reducers/pep/panes/prescription/prescription-consolidate-pep.reducer';
import prescriptionIndividualPEP from 'app/redux/reducers/pep/panes/prescription/prescription-individual-pep.reducer';
import clinicalCenterPEP from 'app/redux/reducers/pep/panes/clinical-center/clinical-center-pep.reducer';
import clinicalCenterStepsPEP from 'app/redux/reducers/pep/panes/clinical-center/clinical-center-steps-pep.reducer';
import equipmentPep from 'app/redux/reducers/pep/panes/equipment/equipment-pep.reducer';
import visitsPEP from 'app/redux/reducers/pep/panes/visits/visits-pep.reducer';
import padVisitsPEP from 'app/redux/reducers/pep/panes/visits/pad-visits-pep.reducer';
import visitStepsPEP from 'app/redux/reducers/pep/panes/visits/visit-steps-pep.reducer';
import visitsPepModal from 'app/redux/reducers/pep/panes/visits/visits-pep.modal.redcucer';
import teleservicePEPModal from 'app/redux/reducers/pep/panes/clinical-center/teleservice-pep-modal.reducer';
import padVisitsPepModal from 'app/redux/reducers/pep/panes/visits/pad-visits-pep.modal.reducer';
import clinicalEvolutionPep from 'app/redux/reducers/pep/panes/clinical-evolution/clinical-evolution-pep.reducer';
import diagnosticPep from 'app/redux/reducers/pep/panes/diagnostic/diagnostic-pep.reducer';
import vitalSignsPep from 'app/redux/reducers/pep/panes/vital-signs/vital-signs-pep.reducer';
// service-product
import serviceProducts from 'app/redux/reducers/service-products.reducer';
// modal
import confirmationModal from 'app/redux/reducers/modal/confirmation-modal.reducer';
import saveUpdateModal from 'app/redux/reducers/modal/save-update-modal.reducer';
import changeStatusModal from 'app/redux/reducers/modal/change-status-modal.reducer';
import simpleModal from 'app/redux/reducers/modal/simple-modal.reducer.js';
import saveUpdateStepsModal from 'app/redux/reducers/modal/save-update-steps-modal.reducer';
import stepsModal from 'app/redux/reducers/modal/steps-modal.reducer';
import simpleFormModal from 'app/redux/reducers/modal/simple-form-modal.reducer';
// furniture
import furniture from 'app/redux/reducers/furniture/furniture.reducer';
// Report
import report from 'app/redux/reducers/report/report.reducer';
import fullReportPDF from 'app/redux/reducers/report/fullReportPDF.reducer';
import extensionReportFilter from 'app/redux/reducers/report/extensionReportFilter.reducer.js';
import healthStandardsReportsPdf from 'app/redux/reducers/report/healthStandardsReportsPdf.reducer.js';
import previewReportModal from 'app/redux/reducers/report/preview-report-modal.reducer.js';
import configurationReport from 'app/redux/reducers/report/report-configuration.reducer.js';
import reportConfigurationModal from 'app/redux/reducers/report/report-configuration-modal.reducer.js';
import reportGenerationLot from 'app/redux/reducers/report/report-generation-lot.reducer.js';
import reportProductivity from 'app/redux/reducers/report-productivity.reducer.js';
import reportProduction from 'app/redux/reducers/report/report-production.reducer.js';
import reportType from 'app/redux/reducers/report-type.reducer';
import verificationReport from 'app/redux/reducers/report/verification-report.reducer';
// Report Audit
import reportAuditModal from 'app/redux/reducers/visit/report-audit/report-audit-modal.reducer';
import reportAuditAnswers from 'app/redux/reducers/visit/report-audit/report-audit-answers.reducer';
import reportAuditStruct from 'app/redux/reducers/visit/report-audit/report-audit-struct.reducer';
// PAD Creator
import padCreator from 'app/redux/reducers/pad-creator/pad-creator.reducer';
import padCreatorEquipment from 'app/redux/reducers/pad-creator/pad-item/equipment/pad-creator-equipment.reducer';
import padCreatorFurniture from 'app/redux/reducers/pad-creator/pad-item/furniture/pad-creator-furniture.reducer';
import padCreatorItemMatMed from 'app/redux/reducers/pad-creator/pad-item/pad-creator-mat-med.reducer';
import padCreatorConfirmationModal from 'app/redux/reducers/pad-creator/pad-creator-confirmation-modal.reducer';
import padCreatorModelModal from 'app/redux/reducers/pad-creator/pad-creator-model-modal/pad-creator-model-modal.reducer';
// PAD Creator - PAD Visit
import padCreatorVisit from 'app/redux/reducers/pad-creator/pad-visit/pad-creator-visit.reducer';
// PAD Creator - PAD Diagnostic
import padCreatorDiagnostic from 'app/redux/reducers/pad-creator/pad-diagnostic/pad-creator-diagnostic.reducer';
import padCreatorDiagnosticConfirmationModal from 'app/redux/reducers/pad-creator/pad-diagnostic/pad-creator-diagnostic-confirmation-modal.reducer';
import padCreatorDiagnosticModal from 'app/redux/reducers/pad-creator/pad-diagnostic/pad-creator-diagnostic-modal.reducer';

// PAD Creator - PAD Prescription
import padCreatorPrescriptionMedicament from 'app/redux/reducers/pad-creator/pad-prescription/pad-creator-prescription-medicament.reducer';
import padCreatorPrescriptionProcedure from 'app/redux/reducers/pad-creator/pad-prescription/pad-creator-prescription-procedure.reducer';
import padCreatorPrescriptionDiet from 'app/redux/reducers/pad-creator/pad-prescription/pad-creator-prescription-diet.reducer';
import padCreatorPrescriptionConfirmationModal from 'app/redux/reducers/pad-creator/pad-prescription/pad-creator-prescription-confirmation-modal.reducer';
import padCreatorVisitConfirmationModal from 'app/redux/reducers/pad-creator/pad-visit/pad-creator-visit-confirmation-modal.reducer';
// PAD Editor
import padEditor from 'app/redux/reducers/pad-editor/pad-editor.reducer';
import padEditorCreateVisitModal from 'app/redux/reducers/pad-editor/create-visit-modal.reducer';
import padEditorEditModal from 'app/redux/reducers/pad-editor/edit-visit-modal.reducer';
import padEditorCreateDiagnosticModal from 'app/redux/reducers/pad-editor/create-diagnostic-modal.reducer';
import padEditorConfirmationModal from 'app/redux/reducers/pad-editor/confirmation-modal.reducer';
import padEditorEditPrescriptionModal from 'app/redux/reducers/pad-editor/edit-prescription-modal.reducer';
import padEditorEditPadDiagnosticModal from 'app/redux/reducers/pad-editor/add-edit-diagnostic-modal.reducer';
import padEditorFurnitureModal from 'app/redux/reducers/pad-editor/pad-editor-furniture-modal.reducer';
import padEditorRemovalConfirmationModal from 'app/redux/reducers/pad-editor/removal-confirmation-modal.reducer';
import padEditorPrescriptionModal from 'app/redux/reducers/pad-editor/pad-prescription/pad-editor-prescription-modal.reducer';
import padEditorPrescriptionConfirmationModal from 'app/redux/reducers/pad-editor/pad-prescription/pad-editor-prescription-confirmation-modal.reducer';
// PAD Editor - PAD Prescription
import padEditorFurniture from 'app/redux/reducers/pad-editor/pad-editor-furniture.reducer';
import padEditorEquipment from 'app/redux/reducers/pad-editor/pad-editor-equipment.reducer';
import padEditorPrescriptionDiet from 'app/redux/reducers/pad-editor/pad-prescription/pad-editor-prescription-diet.reducer';
import padEditorPrescriptionProcedure from 'app/redux/reducers/pad-editor/pad-prescription/pad-editor-prescription-procedure.reducer';
import padEditorPrescriptionMedicament from 'app/redux/reducers/pad-editor/pad-prescription/pad-editor-prescription-medicament.reducer';
// PAD Editor - PAD Item
import padEditorItemMatMed from 'app/redux/reducers/pad-editor/pad-item/pad-editor-mat-med.reducer';
// PAD Creator - Modals
import padCreatorVisitModal from 'app/redux/reducers/pad-creator/pad-visit/pad-creator-visit-modal.reducer';
// import createPadVisitModal from 'app/redux/reducers/pad-creator/create-visit-modal.reducer';
// import suspendPadVisitModal from 'app/redux/reducers/pad-creator/suspend-visit-modal.reducer';
import padCreatorSuspendVisitModal from 'app/redux/reducers/pad-creator/pad-visit/pad-creator-suspend-visit-modal.reducer';
// import alterPadVisitModal from 'app/redux/reducers/pad-creator/alter-visit-modal.reducer';
//import createPadDiagnosticModal from 'app/redux/reducers/pad-creator/create-diagnostic-modal.reducer';
//import padCreatorEquipmentModal from 'app/redux/reducers/pad-creator/pad-creator-equipment-modal.reducer';
import padEditorEquipmentModal from 'app/redux/reducers/pad-editor/pad-editor-equipment-modal.reducer';
// import padCreatorAddEditPrescriptionModal from 'app/redux/reducers/pad-creator/add-edit-prescription-modal.reducer';
// import padCreatorAddPrescriptionModal from 'app/redux/reducers/pad-creator/add-prescription-modal.reducer';
import padCreatorAddPrescriptionModal from 'app/redux/reducers/pad-creator/pad-prescription/pad-creator-add-prescription-modal.reducer';
import padCreatorEditPrescriptionModal from 'app/redux/reducers/pad-creator/pad-prescription/pad-creator-edit-prescription-modal.reducer';

//import padCreatorRemovalConfirmationModal from 'app/redux/reducers/pad-creator/removal-confirmation-modal.reducer';
import padCreatorFurnitureModal from 'app/redux/reducers/pad-creator/pad-item/furniture/pad-creator-furniture-modal.reducer';
import padCreatorFurnitureConfirmationModal from 'app/redux/reducers/pad-creator/pad-item/furniture/pad-creator-furniture-confirmation-modal.reducer';
import padCreatorEquipmentModal from 'app/redux/reducers/pad-creator/pad-item/equipment/pad-creator-equipment-modal.reducer';
import padCreatorEquipmentConfirmationModal from 'app/redux/reducers/pad-creator/pad-item/equipment/pad-creator-equipment-confirmation-modal.reducer';

// PAD MODEL
import padModelCreatorPrescriptionProcedure from 'app/redux/reducers/pad-model-creator/pad-model-creator-prescription/pad-creator-prescription-procedure.reducer';
import padModelCreatorPrescriptionDiet from 'app/redux/reducers/pad-model-creator/pad-model-creator-prescription/pad-creator-prescription-diet.reducer';
import padModelCreatorPrescriptionMedicament from 'app/redux/reducers/pad-model-creator/pad-model-creator-prescription/pad-creator-prescription-medicament.reducer';
import padModelCreatorVisit from 'app/redux/reducers/pad-model-creator/pad-model-creator-visit/pad-model-creator-visit.reducer';
import padModelsEquipment from 'app/redux/reducers/pad-models/pad-item/pad-models-equipment.reducer';
import padModelsFurniture from 'app/redux/reducers/pad-models/pad-item/pad-models-furniture.reducer';
import padModelsInformationModal from 'app/redux/reducers/pad-models/pad-models-information-modal.reducer';
import padModelsChangeStatusModal from 'app/redux/reducers/pad-models/pad-models-change-status-modal.reducer';
import padModelsList from 'app/redux/reducers/pad-models/pad-models-list.reducer';
// PAD MODEL CREATOR
import padModelCreator from 'app/redux/reducers/pad-model-creator/pad-model-creator.reducer';
import PadCreatorDialogBoxProfessionalPrescriptor from 'app/redux/reducers/pad-creator/pad-creator-model-dialog-box/pad-creator-model-dialog-box';
import padModelCreatorVisitModal from 'app/redux/reducers/pad-model-creator/pad-model-creator-visit/pad-model-creator-visit-modal.reducer';
import padModelCreatorFurnitureModal from 'app/redux/reducers/pad-model-creator/pad-model-creator-item/pad-model-creator-furniture-modal.reducer';
import padModelCreatorEquipmentModal from 'app/redux/reducers/pad-model-creator/pad-model-creator-item/pad-model-creator-equipment-modal.reducer';
import padModelEditCreatorPrescriptionModal from 'app/redux/reducers/pad-model-creator/pad-model-creator-prescription/pad-model-creator-edit-prescription-modal.reducer';
import padModelAddCreatorPrescriptionModal from 'app/redux/reducers/pad-model-creator/pad-model-creator-prescription/pad-model-add-creator-prescription.reducer';
import padModelCreatorEquipment from 'app/redux/reducers/pad-model-creator/pad-model-creator-item/pad-model-creator-item-equipment.reducer';
import padModelCreatorItemMatMed from 'app/redux/reducers/pad-model-creator/pad-model-creator-item/pad-model-creator-item-mat-med.reducer';
import padModelCreatorFurniture from 'app/redux/reducers/pad-model-creator/pad-model-creator-item/pad-model-creator-item-furniture.reducer';
import padModelCreatorEquipmentConfirmationModal from 'app/redux/reducers/pad-model-creator/pad-model-creator-item/pad-model-creator-equipment-confirmation-modal.reducer';
import padModelCreatorFurnitureConfirmationModal from 'app/redux/reducers/pad-model-creator/pad-model-creator-item/pad-model-creator-furniture-confirmation-modal.reducer';
// PAD MODEL EDITOR
import padModelEditor from 'app/redux/reducers/pad-model-editor/pad-model-editor.reducer';
import padModelEditorEquipment from 'app/redux/reducers/pad-model-editor/pad-model-editor-item/pad-model-editor-item-equipment.reducer';
import padModelEditorEquipmentModal from 'app/redux/reducers/pad-model-editor/pad-model-editor-item/pad-model-editor-equipment-modal.reducer';
import padModelEditorItemMatMed from 'app/redux/reducers/pad-model-editor/pad-model-editor-item/pad-model-editor-item-mat-med.reducer';
import padModelEditorFurnitureModal from 'app/redux/reducers/pad-model-editor/pad-model-editor-item/pad-model-editor-furniture-modal.reducer';
import padModelEditorFurniture from 'app/redux/reducers/pad-model-editor/pad-model-editor-item/pad-model-editor-item-furniture.reducer';
import padModelEditorEquipmentConfirmationModal from 'app/redux/reducers/pad-model-editor/pad-model-editor-item/pad-model-editor-equipment-confirmation-modal.reducer';
import padModelEditorFurnitureConfirmationModal from 'app/redux/reducers/pad-model-editor/pad-model-editor-item/pad-model-editor-furniture-confirmation-modal.reducer';
import padModelCreatorVisitConfirmationModal from 'app/redux/reducers/pad-model-creator/pad-model-creator-visit/pad-model-creator-visit-confirmation-modal.reducer';
import padModelCreatorPrescriptionConfirmationModal from 'app/redux/reducers/pad-model-creator/pad-model-creator-prescription/pad-model-creator-prescription-confirmation-modal.reducer';
// Reschedule pad
import reschedulePad from 'app/redux/reducers/reschedule-pad/reschedule-pad.reducer';
// Perform Visit
import performVisit from 'app/redux/reducers/perform-visit/perform-visit.reducer';
import feedbackScreenModal from 'app/redux/reducers/feedback-screen-modal.reducer';
// MatMed
import matMedRegisterModal from 'app/redux/reducers/mat-med-list/mat-med-register-modal.reducer';

const appReducer = combineReducers({
  padMenuCooperative,
  errorOverlay,
  saveUpdateStepsModal,
  feedback,
  customHealthScale,
  deleteVisitModal,
  prescriptionMatMed,
  patientVisits,
  padMenuClient,
  previewEvaluation,
  administrationRoute,
  signSymptom,
  evaluationType,
  visitationType,
  branch,
  padMonitoringTabs,
  initializePad,
  padInitialization,
  monitoring,
  padItem,
  padPrescription,
  padVisits,
  padDashboard,
  padDetail,
  calendar,
  evaluations,
  kitMatMed,
  businessPartner,
  measurementUnity,
  cid,
  nandaDomain,
  nandaDiagnostic,
  nandaClass,
  furniture,
  furniturePep,
  procedure,
  serviceProducts,
  routing,
  routingMap,
  plannedVisitsProfessional,
  completedVisitsProfessional,
  attendances,
  visitDetail,
  visitDetailFull,
  extensionReportPDF,
  reportPDFVisitDetail,
  visitsInitialAssessment,
  groupPermissions,
  notificationMessages,
  auth,
  users,
  doctors,
  responsibles,
  healthInsurance,
  nursingTechnician,
  speechTherapists,
  nursingAssistant,
  professionals,
  saveUpdateModal,
  searchAddress,
  changeStatusModal,
  download,
  snackbar,
  visitPages,
  permissions,
  clients,
  equipmentPep,
  matMedPEP,
  visitsPEP,
  padVisitsPEP,
  visitStepsPEP,
  clinicalEvolutionPep,
  clinicalCenterStepsPEP,
  diagnosticPep,
  vitalSignsPep,
  visitsPepModal,
  clinicalCenterPEP,
  teleservicePEPModal,
  checkingCheckoutModal,
  padVisitsPepModal,
  notification,
  notifiables,
  professionalPrescriberModal,
  importPadModal: simpleModal('SEND_PAD_MODAL'),
  patientFileUploadModal: simpleModal('PATIENT_UPLOAD_FILE_MODAL'),
  patientFileViewModal: simpleModal('PATIENT_VIEW_FILE_MODAL'),
  nurseVisitDetailFileViewModal: simpleModal('NURSE_VISIT_DETAIL_VIEW_FILE_MODAL'),
  notificationsModal: simpleModal('NOTIFICATIONS_MODAL'),
  deleteVisitProfessionalModal: simpleModal('DELETE_PROFESSIONAL_VISIT_MODAL'),
  removePatientNurseModal: simpleModal('REMOVE_PATIENT_NURSE_MODAL'),
  removePatientDoctorModal: simpleModal('REMOVE_PATIENT_DOCTOR_MODAL'),
  removePatientSpeechTherapistModal: simpleModal('REMOVE_PATIENT_SPEECH_THERAPIST_MODAL'),
  deletePatientFileModal: simpleModal('DELETE_PATIENT_FILE_MODAL'),
  addDoctorModal: simpleModal('ADD_DOCTOR_MODAL'),
  addSpeechTherapistModal: simpleModal('ADD_SPEECH_THERAPIST_MODAL'),
  addNurseModal: simpleModal('ADD_NURSE_MODAL'),
  professionalAvailabilityVisitsModal: simpleModal('PROFESSIONAL_AVAILABILITY_VISITS_MODAL'),
  // visitDashboard,
  visitDashboardList,
  visitDashboardCounter,
  visitDetailModal: simpleModal('VISIT_DETAIL_MODAL'),
  visitDetailPartialReportModal: simpleModal('VISIT_DETAIL_PARTIAL_REPORT_MODAL'),
  visitDetailExtensionModal: simpleModal('VISIT_DETAIL_EXTENSION_MODAL'),
  visitDetailGlasgowModal: simpleModal('VISIT_DETAIL_GLASGOW_REPORT_MODAL'),
  visitDetailAbemidModal: simpleModal('VISIT_DETAIL_ABEMID_REPORT_MODAL'),
  visitDetailBradenModal: simpleModal('VISIT_DETAIL_BRADEN_REPORT_MODAL'),
  visitDetailKatzModal: simpleModal('VISIT_DETAIL_KATZ_REPORT_MODAL'),
  visitDetailNeadModal: simpleModal('VISIT_DETAIL_NEAD_REPORT_MODAL'),
  totalVisitsAvailabilityVisitsModal: simpleModal('TOTAL_VISITS_AVAILABILITY_VISITS_MODAL'),
  monthVisitsModal: simpleModal('MONTH_VISITS_MODAL'),
  weekVisitsModal: simpleModal('WEEK_VISITS_MODAL'),
  weekPrescriptionModal: simpleModal('WEEK_PRESCRIPTION_MODAL'),
  monthPrescriptionModal: simpleModal('MONTH_PRESCRIPTION_MODAL'),
  monthlyScheduleModal: simpleModal('MONTHLY_SCHEDULE_MODAL'),
  dashboard,
  professionalsVisits,
  monthVisits,
  weekVisits,
  visitReportPDF,
  visitFullReportPDF,

  dashboardSearch,
  patientList,
  patients,
  patientDetail,
  patientFiles,
  patientLastVisits,
  professionalAvailability,
  patientMonthVisits,
  patientWeekVisits,
  weekPrescription,
  kit,
  kitModal,
  equipment,
  matMed,
  evaluationAnswer,
  evaluationQuestion,
  evaluationQuestionOption,
  kitProcedure,
  clinicalEvolution,
  prescriptionTranscription,
  clinicalEvolutionSignSymptom,
  diagnostics,
  diagnosticNANDA,
  diagnosticCID,
  equipmentIndication,
  furnitureIndication,
  professionIndication,
  inventary,
  equipmentInventary,
  furnitureInventary,
  prescription,
  prescriptionPEP,
  prescriptionContent,
  profession,
  healthProfessional,
  report,
  extensionReportFilter,
  fullReportPDF,
  healthStandardsReportsPdf,
  professionalPrescriptorModal,
  professionalPrescriptor,
  healthProfessionalList,
  monthlySchedule,
  padMonitoringVisits,
  reportAuditModal,
  reportAuditAnswers,
  reportAuditStruct,
  reportType,
  patientDetailPEP,
  configurationReport,
  reportGenerationLot,
  reportProductivity,
  reportProduction,
  stepsModal,
  prescriptionConsolidatePEP,
  prescriptionIndividualPEP,
  padCreator,
  padCreatorEquipment,
  padCreatorFurniture,
  padCreatorItemMatMed,
  padCreatorConfirmationModal,
  padEditor,
  padEditorEditModal,
  // createPadVisitModal,
  // suspendPadVisitModal,
  padCreatorVisitModal,
  padCreatorSuspendVisitModal,
  // alterPadVisitModal,
  //createPadDiagnosticModal,
  padCreatorEquipmentModal,
  padEditorEquipmentModal,
  printPrescriptionScheduleSheetModal,
  prescriptionScheduleSheet,
  confirmationModal,
  attendanceReleaseModal,
  padEditorConfirmationModal,
  padEditorCreateVisitModal,
  padEditorCreateDiagnosticModal,
  padEditorFurnitureModal,
  padEditorFurniture,
  padEditorEquipment,
  confirmationPadModal,
  //padCreatorRemovalConfirmationModal,
  padEditorRemovalConfirmationModal,
  // padCreatorAddEditPrescriptionModal,
  padCreatorEditPrescriptionModal,
  padCreatorAddPrescriptionModal,
  previewReportModal,
  reportConfigurationModal,
  linkProfessionalVisitDetail,
  linkProfessionalVisitCalendar,
  linkProfessionalVisit,
  padEditorEditPrescriptionModal,
  padEditorEditPadDiagnosticModal,
  prescriptionMenu,
  prescriptionMenuCards,
  reschedulePad,
  alertBand,
  padCreatorVisit,
  padCreatorDiagnostic,
  padCreatorDiagnosticConfirmationModal,
  padCreatorDiagnosticModal,
  padCreatorFurnitureModal,
  padCreatorFurnitureConfirmationModal,
  padCreatorEquipmentConfirmationModal,
  padCreatorPrescriptionMedicament,
  padCreatorPrescriptionProcedure,
  padCreatorPrescriptionDiet,
  padEditorPrescriptionMedicament,
  padCreatorPrescriptionConfirmationModal,
  padCreatorVisitConfirmationModal,
  padCreatorModelModal,
  padModelEditCreatorPrescriptionModal,
  padModelAddCreatorPrescriptionModal,
  padModelCreatorPrescriptionProcedure,
  padModelCreatorPrescriptionMedicament,
  padModelCreatorPrescriptionDiet,
  padModelCreatorVisit,
  padModelsEquipment,
  padModelsFurniture,
  padModelCreatorItemMatMed,
  padModelCreator,
  padModelsChangeStatusModal,
  padModelsInformationModal,
  padModelsList,
  padModelCreatorVisitModal,
  padModelCreatorFurnitureModal,
  padModelCreatorEquipmentModal,
  padModelCreatorEquipment,
  padModelCreatorFurniture,
  padModelCreatorEquipmentConfirmationModal,
  padModelCreatorFurnitureConfirmationModal,

  padModelEditor,
  padModelEditorFurnitureModal,
  padModelEditorFurniture,
  padModelEditorEquipment,
  padModelEditorEquipmentModal,
  padModelEditorEquipmentConfirmationModal,
  padModelEditorFurnitureConfirmationModal,
  padModelEditorItemMatMed,
  padModelCreatorVisitConfirmationModal,
  padModelCreatorPrescriptionConfirmationModal,
  padEditorPrescriptionModal,
  PadCreatorDialogBoxProfessionalPrescriptor,
  padEditorItemMatMed,
  padEditorPrescriptionDiet,
  padEditorPrescriptionProcedure,
  padEditorPrescriptionConfirmationModal,
  performVisit,
  patientsPEP,
  PEPList,
  visitList,
  feedbackScreenModal,
  crudPatient,
  padListClient,
  matMedRegisterModal,
  simpleFormModal,
  verificationReport
});

export default (state, action) => {
  if (action.type === 'RESET') {
    state = undefined;
  }

  return appReducer(state, action);
};
